/**
 * Created by tong on 2018/2/28
 */
import {config, request} from 'Utils';

/**
 * 购物车列表
 * @param param
 * @returns {*}
 */
export function getShoppingCarList(param) {
    return request(`${config.server}/api/v1/dms/shoppingCart/list`, {
        method: 'post',
        body: param
    });
}

/*购物车删除*/
export function deleteShoppingCarList(param) {
    return request(`${config.server}/api/v1/dms/shoppingCart/delete`, {
        method: 'post',
        body: param
    });
}
/*加入收藏夹*/
export function addFavoritesList(param) {
    return request(`${config.server}/api/v1/dms/collect/insertCollectHaveSpec`, {
        method: 'post',
        body: param
    });
}

/*生成订单*/
/*客户名称接口*/
export function customerList(param) {
    return request(`${config.server}/api/v1/dms/employee/customerList/${param}`,{
        method: 'get'
    });
}
/*购货单位搜索*/
export function getPro(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/gdList`, {
        method: 'post',
        body: param,
    }); 
}

/*选择物料搜索-完成*/
export function getItem(param) {
    return request(`${config.server}/api/v1/dms/product/listPc`, {
        method: 'post',
        body: param,
    });
}

/*购货单位搜索*/
export function getGdList(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/gdList`, {
        method: 'post',
        body: param,
    }); 
}
/*购货单位搜索*/
export function gdList2(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/zyCredit`, {
        method: 'post',
        body: param,
    }); 
}
/*渠道接口*/
export function fetchChannelList(param) {
    return request(`${config.server}/api/v1/dms/homePage/channel`, {
        method: 'get'
    });
}
/*订单类型接口*/
export function fetchChannelList2(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/contractType/${param}`, {
        method: 'get'
    });
}

/*修改数量保存*/
export function changeNum(param) {
    return request(`${config.server}/api/v1/dms/shoppingCart/changeCount`, {
        method: 'post',
        body: param,
    }); 
}


// WEBPACK FOOTER //
// ./src/service/shoppingCar/index.js